// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */

import { LoadableAfterPaint } from '@confluence/loadable';

export const KeyboardShortcutsDialog = LoadableAfterPaint<any>({
	loader: async () => {
		return (
			await import(
				/* webpackChunkName: "loadable-KeyboardShortcutsDialog" */ './NewKeyboardShortcutsDialog.tsx'
			)
		).KeyboardShortcutsDialog;
	},
});
